import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../../constants';

// Style fragments the signed-in home shares between its sections. They mirror
// the landing's card, pill and link treatments so the dashboard reads as the
// same product as the marketing pages, without every section re-declaring them.

export const CARD = {
    boxSizing: 'border-box',
    border: `1px solid ${REDESIGN_COLORS.sand}`,
    borderRadius: '24px',
    background: REDESIGN_COLORS.white,
};

const PILL = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    boxSizing: 'border-box',
    minHeight: '46px',
    padding: '0 22px',
    border: 0,
    borderRadius: '999px',
    fontFamily: REDESIGN_FONTS.body,
    fontSize: '0.95rem',
    fontWeight: REDESIGN_FONTS.weightHeading,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'background 150ms ease, color 150ms ease, border-color 150ms ease',
};

export const PILL_PRIMARY = {
    ...PILL,
    color: REDESIGN_COLORS.white,
    background: REDESIGN_COLORS.primary,
    boxShadow: '0 4px 12px rgba(0, 124, 134, 0.24)',
    '&:hover': {
        color: REDESIGN_COLORS.white,
        background: REDESIGN_COLORS.primaryHover,
    },
    '&:disabled': {
        cursor: 'default',
        boxShadow: 'none',
        color: REDESIGN_COLORS.muted,
        background: REDESIGN_COLORS.line,
    },
};

export const PILL_SECONDARY = {
    ...PILL,
    border: `1px solid ${REDESIGN_COLORS.line}`,
    color: REDESIGN_COLORS.dark,
    background: REDESIGN_COLORS.white,
    '&:hover': {
        borderColor: REDESIGN_COLORS.primary,
        color: REDESIGN_COLORS.link,
    },
};

export const TEXT_LINK = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: REDESIGN_COLORS.link,
    fontSize: '0.92rem',
    fontWeight: REDESIGN_FONTS.weightHeading,
    textDecoration: 'none',
    '&:hover': {
        color: REDESIGN_COLORS.primary,
    },
};

export const KICKER = {
    display: 'block',
    color: REDESIGN_COLORS.muted,
    fontSize: '0.7rem',
    fontWeight: REDESIGN_FONTS.weightHeading,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
};

export const cx = (...names) => names.filter(Boolean).join(' ');
